import React from 'react'
import 'draft-js/dist/Draft.css'
import 'draft-js-static-toolbar-plugin/lib/plugin.css'
import TextEditor from '../Editor/EditorContainer'
import HeaderBar from '../HeaderBar/HeaderBarContainer'

import styles from './TextEditorPage.module.css'

class TextEditorPage extends React.Component {
    render() {
        return (
            <div className={styles.background}>
                <HeaderBar />
                <main className={styles.editor}>
                    <TextEditor />
                </main>
            </div>
        )
    }
}

export default TextEditorPage
